import type { MutationCallbacks } from '#shared'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { updateAlerts } from '../api/update-alerts'
import type { AlertsQueryData } from '../model/alerts-query-data'
import { ALERTS_QUERY_KEY } from './alerts-query'

export function useMarkAlertsAsReadMutation(callbacks: MutationCallbacks<void> = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...callbacks,

    mutationFn: () => updateAlerts({ unreadCount: 0 }),

    onMutate: () => {
      queryClient.setQueryData(ALERTS_QUERY_KEY, (queryData: AlertsQueryData | undefined) => {
        if (!queryData) return

        const newPages = queryData.pages.map(page => ({
          ...page,
          unreadCount: 0,
        }))

        return {
          ...queryData,
          pages: newPages,
        }
      })

      callbacks?.onMutate?.()
    },
  })
}
